module.exports = __webpack_public_path__ + "images/eet-je-liever-brood-b.360w.jpg";